import * as React from 'react';
import { observer } from 'mobx-react';
import { PageHeader } from './page-header';
import {em, px, rem} from 'csx';
import { mediaTablet, mediaMobileOnly } from '../theme/media';
import { style } from 'typestyle';
import { LoadingContainer } from './loading-container';
import { PagePricing } from './page-pricing';
import { horizontal, start, vertical } from 'csstips';

const PrismicDOM = require('prismic-dom');

export interface PageGenericPrismicModel {
  loading: boolean;
  page_title: any;
  page_body: any;
  cover_image: string;
  video_id?: string;
}

export interface PageGenericPrismicProps {
  model: PageGenericPrismicModel;
}

@observer
export class PageGenericPrismic extends React.Component<PageGenericPrismicProps, any> {
  render() {
    const { model, children } = this.props;

    return (
      <LoadingContainer loading={model.loading}>
        <PageHeader
          coverImage={model.cover_image}
          dangerouslySetInnerHTML={{ __html: model.loading ? null : PrismicDOM.RichText.asHtml(model.page_title) }}
        />
        {!model.loading && (
          <div className={PageGenericPrismic.styles.split}>
            <div>
              <div
                className={PageGenericPrismic.styles.content}
                dangerouslySetInnerHTML={{ __html: PrismicDOM.RichText.asHtml(model.page_body) }}
              />
              {children ? children : null}
            </div>
            {model.video_id && (
              <div>
                <div className={PagePricing.styles.playerContainer}>
                  <div className={PagePricing.styles.player}>
                    <iframe className={PagePricing.styles.faq}
                            src={`https://www.youtube.com/embed/${model.video_id}?autoplay=0&origin=https://lickd.co`}
                            frameBorder="0" />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </LoadingContainer>
    )
  }

  static styles = {
    split: style(
      mediaMobileOnly({
        ...vertical,
        flexDirection: 'column-reverse',
        padding: '60px 20px'
      }),
      mediaTablet({
        ...horizontal,
        ...start,
        padding: px(80),
        $nest: {
          '&> div': {
            flex: 1
          },
          '&> div:nth-child(2)': {
            marginLeft: px(80)
          }
        }
      })
    ),
    content: style(
      {
        maxWidth: em(54),
        margin: '0 auto 0 0',
        $nest: {
          '&> div': {
            margin: '0 0 60px 0'
          },
          '& ol': {
            margin: '1.25rem 0',
            padding: '0 0 0 2.5rem',
          },
          '& ul': {
            margin: '1.25rem 0',
            padding: '0 0 0 2.5rem',
          },
          '& li': {
            margin: 0,
            padding: 0,
          },
          '& li + li': {
            marginTop: rem(1.25)
          }
        }
      }
    )
  }
}